import { useNavigate } from "react-router-dom";
import { getCompanyConfig } from "../api";
import "./Header.css";

export default function Header() {
  const navigate = useNavigate();
  const departmentData = JSON.parse(localStorage.getItem("department")) || {};
  const company = getCompanyConfig();

  function handleLogout() {
    localStorage.clear();
    navigate("/");
  }

  return (
    <header className="credo-header">
      <div className="header-left">
        {company?.logo_url ? (
          <img src={company.logo_url} className="header-logo-image" alt={company.name} />
        ) : (
          <div className="brand-wordmark" aria-label="AI კანცელარია">
            <span className="brand-mark">
              <span className="brand-mark-text">AI</span>
              <span className="brand-mark-glint" />
            </span>
            <span className="brand-name">კანცელარია</span>
          </div>
        )}
      </div>

      <div className="header-right">
        <div className="header-user">
          <div className="header-user-avatar">
            {(departmentData.department_name || "?")[0]}
          </div>
          <span className="header-dept">{departmentData.department_name || ""}</span>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          გასვლა
        </button>
      </div>
    </header>
  );
}
